// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"358":"npm.echarts","2210":"npm.zrender","4024":"npm.semver","8565":"npm.crypto-js"}[chunkId] || chunkId) + ".1755164132056.js";
};